import { LayoutGrid, Home, Package, ShoppingBag, UserRound } from "lucide-react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../contexts/CartContext";

const navItems = [
  { label: "Home", to: "/", icon: Home, testId: "nav-item-home" },
  { label: "Categories", to: "/categories", icon: LayoutGrid, testId: "nav-item-categories" },
];

export function BottomNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { count } = useCart();

  const iconClass = "h-5 w-5";
  const itemClass = (active) =>
    `flex min-h-14 min-w-14 flex-1 flex-col items-center justify-center gap-1 px-1 text-[10px] ` +
    `font-semibold transition-colors ${active ? "text-[#FF5200]" : "text-stone-500"}`;

  return (
    <nav
      aria-label="Primary mobile navigation"
      className={
        "fixed inset-x-0 bottom-0 z-[1000] flex h-[5rem] items-center border-t border-stone-200 " +
        "bg-white/95 px-1 pb-[env(safe-area-inset-bottom)] " +
        "shadow-[0_-8px_24px_rgba(28,25,23,0.08)] backdrop-blur"
      }
      data-testid="mobile-bottom-navigation"
    >
      {navItems.map(({ label, to, icon: Icon, testId }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          data-testid={testId}
          className={({ isActive }) => itemClass(isActive)}
        >
          <Icon className={iconClass} strokeWidth={2} />
          <span>{label}</span>
        </NavLink>
      ))}
      <button
        type="button"
        aria-label={`Cart${count ? `, ${count} items` : ""}`}
        className={`${itemClass(location.pathname === "/cart")} -mt-7`}
        data-testid="nav-item-cart"
        onClick={() => navigate("/cart")}
      >
        <span className="relative">
          <span className="grid h-14 w-14 place-items-center rounded-full border-4 border-white bg-[#FF5200] text-white shadow-lg">
            <ShoppingBag className={iconClass} strokeWidth={2.5} />
          </span>
          {count > 0 && (
            <span
              className={
                "absolute -right-2 -top-1 grid h-5 min-w-5 place-items-center rounded-full " +
                "border-2 border-white bg-slate-900 px-1 text-[9px] font-bold text-white"
              }
              data-testid="mobile-cart-count"
            >
              {count}
            </span>
          )}
        </span>
        <span className="-mt-1">Cart</span>
      </button>
      <NavLink to="/orders" data-testid="nav-item-orders" className={({ isActive }) => itemClass(isActive)}>
        <Package className={iconClass} strokeWidth={2} />
        <span>Orders</span>
      </NavLink>
      <NavLink to="/account" data-testid="nav-item-account" className={({ isActive }) => itemClass(isActive)}>
        <UserRound className={iconClass} strokeWidth={2} />
        <span>Account</span>
      </NavLink>
    </nav>
  );
}
